export default "__VITE_ASSET__c4ea9100__"